// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gs-a";
export var fulfillmentFormRail = "_gs-9";
export var headerTitleRow = "_gs-c";
export var orderDetailsWrapper = "_gs-7";
export var orderLinkTrigger = "_gs-2";
export var paymentInformationGrid = "_gs-h";
export var paymentSummaryColumn = "_gs-i";
export var shipmentContainer = "_gs-b";
export var shipmentDetailsMainPane = "_gs-8";
export var shipmentNavigationCard = "_gs-5";
export var shipmentNavigationRail = "_gs-3";
export var shipmentNavigationRailHeader = "_gs-4";
export var shipmentSummaryFact = "_gs-e";
export var shipmentSummaryGrid = "_gs-d";
export var shipmentSummaryMetadataRow = "_gs-f";
export var shipmentSummaryTags = "_gs-g";
export var shipmentWorkspace = "_gs-0";
export var shipmentWorkspaceContent = "_gs-6";
export var shipmentWorkspaceHeader = "_gs-1";